import { createContext, useContext } from 'react'

import { TechnicalError } from '@orus.eu/error'

const chatContext = createContext<() => void>(() => {
  throw new TechnicalError('openChat not initialized')
})

export function useOpenChat(): () => void {
  return useContext(chatContext)
}

export const ChatProvider: React.Provider<() => void> = chatContext.Provider
